/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useContext, useMemo, useState } from 'react';
import { calculateVanAgeInYears } from '../utils/lettings';
const DEFAULT_VALUES = {
    token: '',
    setToken: () => { },
    activeAccountId: null,
    setActiveAccountId: () => { },
    setUser: () => { },
    userType: null,
    loggedInUser: null,
    activeAccount: null,
    gtmPageViewAuthInfo: {},
    shouldRefetchUser: false,
    refetchUser: () => { },
    setLettingInformation: () => { },
};
export const AuthContext = createContext(DEFAULT_VALUES);
export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState('');
    const [activeAccountId, setActiveAccountId] = useState(null);
    const [user, setUser] = useState(null);
    const [shouldRefetchUser, refetchUser] = useState(false);
    const [lettingInformation, setLettingInformation] = useState(null);
    const userType = useMemo(() => (user === null || user === void 0 ? void 0 : user.userType) || null, [user]);
    const loggedInUser = useMemo(() => ((user === null || user === void 0 ? void 0 : user.userType) === 'USER' ? user : null), [user]);
    const activeAccount = useMemo(() => (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.accounts.find(({ accountID }) => accountID === activeAccountId)) || null, [loggedInUser, activeAccountId]);
    const gtmPageViewAuthInfo = useMemo(() => {
        var _a, _b;
        return ({
            authStatus: loggedInUser ? 'logged in' : 'logged out',
            ownerId: loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.ownerId,
            parkCode: activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.parkCode,
            ownerAccount: activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountNo,
            ownerType: loggedInUser
                ? (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.acceptedForLet)
                    ? 'letting with haven'
                    : 'not letting with haven'
                : 'not set',
            lettingType: loggedInUser
                ? (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.acceptedForLet)
                    ? (_a = activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountType) === null || _a === void 0 ? void 0 : _a.description.toLowerCase()
                    : null
                : null,
            lettingPropositionType: loggedInUser
                ? (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.acceptedForLet)
                    ? (_b = lettingInformation === null || lettingInformation === void 0 ? void 0 : lettingInformation.fixedOrFlexi) === null || _b === void 0 ? void 0 : _b.toLowerCase()
                    : null
                : null,
            lettingEligibility: loggedInUser
                ? (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.acceptedForLet)
                    ? null
                    : (lettingInformation === null || lettingInformation === void 0 ? void 0 : lettingInformation.eligbleToLet)
                        ? 'eligible'
                        : 'ineligible'
                : null,
            vanYear: loggedInUser && (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.vanYear) ? String(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.vanYear) : null,
            vanAge: loggedInUser && (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.vanYear)
                ? calculateVanAgeInYears(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.vanYear)
                : null,
        });
    }, [loggedInUser, activeAccount, lettingInformation]);
    return (<AuthContext.Provider value={{
            token,
            setToken,
            activeAccountId,
            setActiveAccountId,
            setUser,
            userType,
            loggedInUser,
            activeAccount,
            gtmPageViewAuthInfo,
            shouldRefetchUser,
            refetchUser,
            setLettingInformation,
        }}>
      {children}
    </AuthContext.Provider>);
};
export const useAuthContext = () => useContext(AuthContext);
